/**
 * @generated SignedSource<<ac936e4627a3fcf833a8db0277fd8fed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PortfolioProjectTextCoverStyle = "COLOR_BLACK" | "COLOR_BLUE" | "COLOR_GREEN" | "COLOR_ORANGE" | "COLOR_PURPLE" | "COLOR_SALMON" | "COLOR_WATERMELON" | "COLOR_WHITE" | "COLOR_YELLOW" | "SHAPE_COINS_DARK" | "SHAPE_COINS_LIGHT" | "SHAPE_COLLABORATION_DARK" | "SHAPE_COLLABORATION_LIGHT" | "SHAPE_FOCUS_DARK" | "SHAPE_FOCUS_LIGHT" | "SHAPE_GAIN_DARK" | "SHAPE_GAIN_LIGHT" | "SHAPE_STAIRS_DARK" | "SHAPE_STAIRS_LIGHT" | "SHAPE_WAVE_DARK" | "SHAPE_WAVE_LIGHT" | "SVG_BLUE" | "SVG_BLUE2" | "SVG_LINES_BLUE" | "SVG_LINES_GREEN" | "SVG_LINES_ORANGE" | "SVG_LINES_PURPLE" | "SVG_LINES_SALMON" | "SVG_LINES_YELLOW" | "SVG_WHITE" | "SVG_WHITE2" | "SVG_YELLOW" | "SVG_YELLOW2" | "VAPOR_GRADIENT_BLUE_DARK" | "VAPOR_GRADIENT_BLUE_LIGHT" | "VAPOR_GRADIENT_GREEN_DARK" | "VAPOR_GRADIENT_GREEN_LIGHT" | "VAPOR_GRADIENT_PURPLE_DARK" | "VAPOR_GRADIENT_PURPLE_LIGHT" | "VAPOR_GRADIENT_SALMON_DARK" | "VAPOR_GRADIENT_SALMON_LIGHT" | "VAPOR_GRADIENT_WATERMELON_DARK" | "VAPOR_GRADIENT_WATERMELON_LIGHT" | "VAPOR_GRADIENT_WHITE_DARK" | "VAPOR_GRADIENT_YELLOW_LIGHT" | "%future added value";
export type ProductizedServiceDurationInterval = "DAY" | "WEEK" | "%future added value";
export type ProductizedServicePriceInterval = "DAY" | "HOUR" | "MONTH" | "WEEK" | "%future added value";
export type ProductizedServicePriceType = "CONTACT_FOR_PRICING" | "FIXED_PRICE" | "RATE" | "%future added value";
export type ProductizedServiceType = "BUY_NOW_INSTANT_PURCHASE" | "BUY_NOW_OTHER" | "BUY_NOW_REQUEST" | "NOT_PURCHASABLE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Services_userProfile$data = {
  readonly productizedServices: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly analyticsId: number;
        readonly duration: {
          readonly amount: number;
          readonly interval: ProductizedServiceDurationInterval;
        } | null;
        readonly id: string;
        readonly portfolioProjects: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly analyticsId: number;
              readonly cover: {
                readonly __typename: "PortfolioProjectImageCover";
                readonly image: {
                  readonly animated: boolean;
                  readonly height: number;
                  readonly id: string;
                  readonly originalFormat: string;
                  readonly sizeBytes: number;
                  readonly uid: string;
                  readonly width: number;
                };
              } | {
                readonly __typename: "PortfolioProjectTextCover";
                readonly style: PortfolioProjectTextCoverStyle;
              } | {
                // This will never be '%other', but we need some
                // value in case none of the concrete values match.
                readonly __typename: "%other";
              };
              readonly id: string;
              readonly slug: string;
              readonly title: string;
            };
          }>;
        };
        readonly price: {
          readonly amount: number | null;
          readonly interval: ProductizedServicePriceInterval | null;
          readonly timeline: string | null;
          readonly type: ProductizedServicePriceType;
        };
        readonly productizedServiceType: ProductizedServiceType | null;
        readonly slug: string;
        readonly title: string;
      };
    }>;
  };
  readonly " $fragmentType": "Services_userProfile";
};
export type Services_userProfile$key = {
  readonly " $data"?: Services_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"Services_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "analyticsId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "interval",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Services_userProfile",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "excludeDrafts",
          "value": true
        }
      ],
      "concreteType": "UserProfileProductizedServiceConnection",
      "kind": "LinkedField",
      "name": "productizedServices",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserProfileProductizedServiceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductizedService",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductizedServicePortfolioProjectConnection",
                  "kind": "LinkedField",
                  "name": "portfolioProjects",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductizedServicePortfolioProjectEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PortfolioProject",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v1/*: any*/),
                            (v3/*: any*/),
                            (v2/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "cover",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v4/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "ContraImage",
                                      "kind": "LinkedField",
                                      "name": "image",
                                      "plural": false,
                                      "selections": [
                                        (v1/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "animated",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "height",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "originalFormat",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "sizeBytes",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "uid",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "width",
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "type": "PortfolioProjectImageCover",
                                  "abstractKey": null
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v4/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "style",
                                      "storageKey": null
                                    }
                                  ],
                                  "type": "PortfolioProjectTextCover",
                                  "abstractKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "productizedServiceType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductizedServiceDuration",
                  "kind": "LinkedField",
                  "name": "duration",
                  "plural": false,
                  "selections": [
                    (v5/*: any*/),
                    (v6/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductizedServicePrice",
                  "kind": "LinkedField",
                  "name": "price",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    (v6/*: any*/),
                    (v5/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "timeline",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "productizedServices(excludeDrafts:true)"
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "81c1aac811bc72adee957767fccece36";

export default node;
